module.exports = __webpack_public_path__ + "static/media/212-vip-men-big.ee2591e6.png";